export default __webpack_public_path__ + "static/media/356EBC_2B_0.288cdf58.woff2";